import Emitter from 'tiny-emitter';
const emitter = new Emitter();

export default class EventService {

    static emit(event) {
        emitter.emit(event);
    }

    static on(event, callback) {
        emitter.on(event, callback);
    }

    static off(event) {
        if(event) {
            emitter.off(event);
        } else {
            emitter.off();
        }
    }
    
    static notification(title, content) {
        let msg = { title, content }

        fetch('https://us-central1-hunt-country.cloudfunctions.net/sendNotification', {
            headers: {
                'Accept': 'application/x-www-form-urlencoded',
                'Content-Type': 'application/json'
            },          
            method: 'POST',
            body: JSON.stringify(msg)
        })
        .then(result => result.text())
        .then(result => {
            console.log("Notification Result", result)
        })
        .catch(err => {
            console.log("Notification Error", err)
        })
    }
}